import axios from "axios";

const getCatalogoItems = async (page = 1, pageSize = 10, filtro = "") => {
  // Read latest values at call time to avoid stale/undefined payload
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const puesto = JSON.parse(localStorage.getItem("puesto") || "null");
  const idPuesto = puesto?.idPuesto;

  const userData = {
    nic: formattedNic || null,
    token: token || null,
    page,
    pageSize,
    filtro: filtro || "",
    idPuesto: idPuesto ?? null,
    serialNumberKeyClover:
      localStorage.getItem("serialNumberKeyClover") || null,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/Catalogo/GetCatalogoItemsPorPuesto`,
      userData,
    );
    return response.data; // Ensure to return the actual data
  } catch (error) {
    // Re-throw to be handled by caller (UI already handles falsey result)
    throw error;
  }
};

const getArticulosItems = async (page = 1, pageSize = 10, filtro = "", id) => {
  // Read latest values at call time
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic || null,
    token: token || null,
    page,
    pageSize,
    filtro: filtro || "",
    id,
    serialNumberKeyClover:
      localStorage.getItem("serialNumberKeyClover") || null,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/Catalogo/GetArticulosPorGrupoOCategoria`,
      userData,
    );
    return response.data; // Ensure to return the actual data
  } catch (error) {
    throw error;
  }
};

const getImagen = async codigoYpf => {
  const userData = {
    codigoYpf: codigoYpf,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/Catalogo/GetImagen`,
      userData,
      {
        responseType: "arraybuffer", // Importante: especificar que esperamos datos binarios
      },
    );
    return response.data; // Devolver los datos binarios
  } catch (error) {
    throw error;
  }
};

const getImagenArticulo = async idArticulo => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    idArticulo: idArticulo,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/Catalogo/GetImagenArticulo`,
      userData,
    );
    return response.data; // Devolver los datos binarios
  } catch (error) {
    throw error;
  }
};

const catalogo = {
  getCatalogoItems,
  getArticulosItems,
  getImagenArticulo,
  getImagen,
};

export default catalogo;
